import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "./payments.css"; // Import CSS for styling

const stripePromise = loadStripe("pk_live_51QwoORHfajrG1onSHMhsnH1V9Cdvm1e4kpZL2rDoE4BLQqbkFfBGhNhOuVrJH7sfkvwvCclYy1tOYAm55Wxa1UHA00RNJ8j5Cu");

const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [amount, setAmount] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const calculateTotalWithSurcharge = (amount) => {
        const surcharge = amount * 0.03; // 3% surcharge
        return (parseFloat(amount) + surcharge).toFixed(2); // Return total with 2 decimal places
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        setProcessing(true);
        setError(null);

        try {
            const totalAmount = calculateTotalWithSurcharge(amount);
            const { clientSecret } = await fetch("/api/create-payment-intent", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    amount: parseFloat(totalAmount) * 100,
                    name, 
                    email 
                }) 
            }).then(res => res.json());

            const cardElement = elements.getElement(CardElement);
            const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: cardElement,
                    billing_details: { name, email },
                },
            });

            if (error) {
                setError(error.message);
            } else if (paymentIntent.status === "succeeded") {
                setSuccess(true);
            }
        } catch (err) {
            setError("An error occurred while processing the payment.");
        } finally {
            setProcessing(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input 
                type="text" 
                placeholder="Enter your name" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
                required
            />
            <input 
                type="email" 
                placeholder="Enter your email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required
            />
            <input 
                type="number" 
                placeholder="Enter amount due on bill" 
                value={amount} 
                onChange={(e) => setAmount(e.target.value)} 
                required
            />
            <p style={{ fontSize: "12px", color: "red" }}>
                        * A 3% credit card surcharge is applied to all payments.
                    </p>
            {amount && (
                <div className="total-amount">
                    <p>
                        <strong>Total with 3% Credit Card Surcharge:</strong> ${calculateTotalWithSurcharge(amount)}
                    </p>
                </div>
            )}
            <div className="StripeElement">
                <CardElement
                    options={{
                        style: {
                            base: {
                                fontSize: "20px",
                                color: "#333",
                                "::placeholder": {
                                    color: "#888",
                                },
                                padding: "15px",
                            },
                        },
                    }}
                />
            </div>
            <button type="submit" disabled={!stripe || processing}>
                {processing ? "Processing..." : "Pay Now"}
            </button>
            {error && <div style={{ color: "red" }}>{error}</div>}
            {success && <div style={{ color: "green" }}>Payment successful!</div>}
        </form>
    );
};

const Payment = () => (
    <div className="payment-container">
        <div className="payment-content">
            <h1 className="payment-banner">Welcome to the Online Bill Payment Portal</h1>
            <p style={{ textAlign: 'center', fontSize: '18px', marginBottom: '20px' }}>
                Fill out the following information to pay your bill. Enter the amount owed from the bill we sent you!
            </p>
            <div className="payment-box">
                <Elements stripe={stripePromise}>
                    <CheckoutForm />
                </Elements>
            </div>
        </div>
    </div>
);

export default Payment;
